export const NOTIFICATIONS_GROUP = {
  CONSENT_NOTIFICATION: 1,
  STANDARD_NOTIFICATION: 2,
};
